import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://superbuy.baby';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Baby',
  url: SITE_URL,
  description: 'Ultimate Superbuy spreadsheet collection with product categories, shopping guides, and expert tips.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Baby',
  url: SITE_URL,
  description: 'Your trusted source for the best Superbuy spreadsheet collections, product sourcing guides, and international shopping tips. Updated daily for 2026.',
  sameAs: ['https://kaspreadsheet.com/'],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }} />
      <header>
        <Navbar />
      </header>
      <main>
        <Hero />
        <CategoryGrid />
        <ArticlesSection />
        <CTASection />
        <AboutSection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}